import axios from '../util/axiosUtil.js'

// 获取公司简介信息
export function getCompanyProfile() {
    return axios({
        url: '/api/ContentManagement/anotherCompanyProfile',
        method: 'get'
    })
}

// 获取大事记信息
export function getMajorEvents() {
    return axios({
        url: '/api/ContentManagement/majorEvents',
        method: 'get'
    })
}

// 获取联系我们信息
export function getContactUs() {
    return axios({
        url: '/api/ContentManagement/contactUs',
        method: 'get'
    })
}

// 发送弹幕留言
export function sendBarrage(data) {
    return axios({
        url: '/api/Barrage/Barrage',
        method: 'post',
        data: data
    })
}

// 获取弹幕信息
export function getBarrageList() {
    return axios({
        url: '/api/Barrage/Barrage/Publish',
        method: 'get'
    })
}
